import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";

// External components
import Loading from "@/components/loading/loading";
import MealsCarousel from "@/components/mealsCarousel/mealsCarousel";
import EditDishModal from "@/components/editDishModal/editDishModal";
import TagsModal from "@/components/tagsModal/tagsModal";
import OnBoardingSubscriptionSummary from "@/components/onBoardingSubscrpitionSummary/onBoardingSubscriptionSummary";
import ContactHost from "@/components/contactHost/contactHost";
import IngredientModal from "@/components/ingredientModal/ingredientModal";
import CollapsibleContent from "@/components/collapsibleContent/collapsibleContent";

// Helpers
import { localCurrency } from "@/plugins/currency";

@Component({
  components: {
    Loading,
    MealsCarousel,
    EditDishModal,
    TagsModal,
    OnBoardingSubscriptionSummary,
    ContactHost,
    IngredientModal,
    CollapsibleContent,
  },
  methods: {
    localCurrency,
  },
})
export default class OnBoardingStep1 extends Vue {
  @Prop({ default: false }) isGoingToNextStep;

  @Getter getSubscription;
  @Getter getUser;
  @Getter getMenus;
  @Getter getIsUnderMobile;

  @Mutation SET_SELECTED_MENU_ID;

  isLoading = false;
  isShowingEditDishModal = false;
  isShowingTagsModal = false;
  isShowingIngredientsModal = false;
  selectedDish = null;

  get isValid() {
    const { details } = this.getSubscription;
    let response = false;
    let i = 0;
    while (i < details.length && !response) {
      if (details[i].count > 0) response = true;
      i++;
    }
    return response;
  }

  @Watch("isGoingToNextStep")
  onIsGoingToNextStepChange() {
    if (this.isGoingToNextStep) {
      this.goToNextStep();
      this.$emit("change-is-going-to-next-step");
    }
  }

  getMenuById(menuId) {
    let response = null;
    if (this.getMenus && this.getMenus.length) {
      response = this.getMenus.find((menu) => menu.id === menuId);
    }
    return response;
  }

  toggleIngredientsModal(dish) {
    if (dish) {
      this.selectedDish = dish;
      this.isShowingIngredientsModal = true;
    } else {
      this.selectedDish = null;
      this.isShowingIngredientsModal = false;
    }
  }

  addIngredient() {
    this.$router.push("/mi-menu/ingredientes");
  }

  goToNextStep() {
    if (this.isValid) {
      this.$emit("next-step");
    } else {
      this.$swal({
        title: "Error",
        text: "Falló la validación. Debes agregar al menos un menú a tu suscripción",
      });
    }
  }
}
